import { TextInput, required, PasswordInput, useTranslate, DateInput } from 'react-admin';
import { Grid } from '@mui/material';
import { DatePickerInput } from '../../components/fields/inputs';



export default function VaultConnectionAspireForm({configurationKeys}) {
    console.log("Congigutation:", configurationKeys)
    const translate = useTranslate();
    return (
        <Grid>
            {configurationKeys.indexOf('client_id') >= 0 &&
                <Grid item lg={12} xs={12}>
                    <TextInput
                        fullWidth
                        autoComplete="new-clientsecret" 
                        source="client_id"
                        label={translate('resources.integrations.aspire.client_id')}
                        validate={required()}
                    />
                </Grid>
            }
            {configurationKeys.indexOf('secret') >= 0 &&
                <Grid item lg={12} xs={12}>
                    <PasswordInput
                        fullWidth
                        autoComplete="new-clientsecret" 
                        source="secret"
                        validate={required()}
                    />
                </Grid>
            }
            {configurationKeys.indexOf('attendance_import_from_date') >= 0 &&
                <Grid item lg={12} xs={12}>
                    <DatePickerInput 
                        source="attendance_import_from_date"
                        label={translate('resources.integrations.aspire.attendance_import_from_date')} />
                    
                </Grid>
            }
        </Grid>
    )
}
